export const getFromLocalStorage = <T>(key: string): T | null => {
  const storedValue = window.localStorage.getItem(key);

  if (!storedValue) return null;

  try {
    return JSON.parse(storedValue) as T;
  } catch {
    return null;
  }
};

export const setInLocalStorage = <T>(key: string, value: T): void => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const removeFromLocalStorage = (key: string): void => window.localStorage.removeItem(key);
